var map = {
	"./logo.svg": 59,
	"./og-image.jpg": 141,
	"./portrait-patrickvoegeli.jpg": 80,
	"./teaser-5g-faktencheck.jpg": 142,
	"./teaser-darknet.jpg": 143,
	"./teaser-das-steckt-drin.jpg": 144,
	"./teaser-der-abend-kompakt.jpg": 145,
	"./teaser-geldwaeschereiquiz.jpg": 146,
	"./teaser-jogging-routen-zh.jpg": 147,
	"./teaser-klimazukunft.jpg": 148,
	"./teaser-lohnvergleich.jpg": 149,
	"./teaser-prognose-staenderatswahlen.jpg": 150,
	"./teaser-schneetage.jpg": 151,
	"./teaser-sommerbilanz.jpg": 152,
	"./teaser-staedtequiz.jpg": 153
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 140;